import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/products/all/`    
  }),
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: () => ({
        url: `count`
      }),
    }),
  }),
})

export const { useGetProductsQuery } = productApi